import AppProvider from 'providers/AppProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from 'providers/BreakpointsProvider';
import SettingsPanelProvider from 'providers/SettingsPanelProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from 'Routes';
//import ChatWidgetProvider from 'providers/ChatWidgetProvider';
import MediaWidgetProvider from 'providers/MediaWidgetProvider';
import { UserProvider } from 'contexts/UserContext'; // Adjust the path if needed

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <UserProvider>
    <AppProvider>
      <SettingsPanelProvider>
        {/* <ChatWidgetProvider> */}
        <MediaWidgetProvider>
          <BreakpointsProvider>
            <RouterProvider router={router} />
          </BreakpointsProvider>
          {/* </ChatWidgetProvider> */}
        </MediaWidgetProvider>
      </SettingsPanelProvider>
    </AppProvider>
  </UserProvider>
  // </React.StrictMode>
);
